export enum AppErrorKind {
	SignIn = "SIGN_IN",
	SignOut = "SIGN_OUT",
	Auth = "AUTH",
}
